/**
 * Determine the currency for a given locale based on region code
 * Supports expanding to other locales as needed
 */
export const getCurrencyForLocale = (locale: string): string => {
  const region = locale.split('-')[1];
  // Map region codes to their default currencies
  const regionCurrencyMap: Record<string, string> = {
    'CA': 'CAD',  // Canada
    'US': 'USD',  // United States
  };
  return regionCurrencyMap[region] || 'USD';
};
